import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, ListItem, ListItemAvatar, ListItemText, Tooltip, Typography } from '@material-ui/core';

import { UserAvatarGroup } from '../../../Common/UserAvatarGroup';
import { FeedbackReviewerCommentForm } from './FeedbackReviewerCommentForm';
import { PopperMenu } from '../../../Admin/CommonComponent/PopperMenu';
import { DeleteIcon, EditIcon } from '../../../../config/svg/CommonSvg';
import { getFullName, getGlobalTaskListDueDate, getUserName, getTime } from '../../../../config/utils';
import { Enums } from '../../../../config/enums';
import { useDispatch } from 'react-redux';
import { deletePipComment, getPipComments, savePipComments } from '../../../../action/performanceImprovementPlan';
import { OKRButton } from '../../../Common/OKRButton';
import CkEditor from '../../../Common/CkEditor/CkEditor';
import AlertDialog from '../../../Common/Dialog';
import { AnimatedIcon } from '../../../Common/AnimatedIcon';
import NofoundImg from '../../../../images/no-found-conversation.svg';

export const FeedbackReviewersComment = (props: any) => {
	const {
		feedbackFormType,
		feedbackDetails,
		creatorDetailsVal,
		reviewerDetailsVal,
		loader,
		setIsFormEdited,
		setLoader,
		showMsg,
		userDetails,
		feedbackItem,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const reviewFormStaticDataObj = {
		commentDetailsId: Enums.ZERO,
		comments: '',
		moduleDetailsId: Enums.ZERO,
		moduleId: Enums.ZERO,
	};

	const [anchorEl, setAnchorEl] = useState(null);
	const [popperMenuClicked, setPopperMenuClicked] = useState<boolean>(false);
	const [showEditor, setShowEditor] = React.useState<boolean>(false);
	const [reviewFormData, setReviewFormData] = useState<any>(reviewFormStaticDataObj);
	const [modalProps, setModalProps] = useState<any>({ open: false, event: {}, message: '' });
	const [commentListDetails, setCommentListDetails] = useState<any>(null);
	const [reviewDatesComments, setReviewDatesComments] = useState<any>(null);
	const [highlightCommentId, setHighlightCommentId] = useState<any>(null);
	useEffect(() => {
		if (feedbackDetails?.feedbackId) {
			getPipCommentsApiCall(feedbackDetails?.feedbackId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [feedbackDetails]);

	useEffect(() => {
		if (feedbackItem?.commentId) {
			setHighlightCommentId(feedbackItem.commentId);

			setTimeout(() => {
				setHighlightCommentId(null);
			}, 5000);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [feedbackItem]);
	const getPipCommentsApiCall = async (feedbackId: any) => {
		try {
			const requestParam = `moduleDetailsId=${feedbackId || Enums.ZERO}&pageIndex=${1}&pageSize=${
				Enums.MAX_USER_SIZE
			}&moduleId=${Enums.FOUR}`;
			const response: any = await dispatch(getPipComments(requestParam));
			if (response && response?.data && response.data?.status === Enums.STATUS_SUCCESS) {
				const { commentResponses } = response?.data?.entity || {};
				setReviewDatesComments(response?.data?.entity || null);
				setCommentListDetails(commentResponses?.results || []);
				setLoader(false);
			} else {
				const { messageList } = response?.data || {};
				const keys = messageList ? Object.keys(messageList) : [];
				const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
				showMsg('error', messages || `Error occurred while fetching comments`);
				setReviewDatesComments(null);
				setCommentListDetails([]);
				setLoader(false);
			}
		} catch (error) {
			console.error(error);
			setReviewDatesComments(null);
			setCommentListDetails([]);
			setLoader(false);
		}
	};
	const handleChangeCommentValue = (value: any) => {
		setIsFormEdited(true);
		setReviewFormData({ ...reviewFormData, comments: value });
	};
	const handleCancelCommentClick = (event: any) => {
		try {
			setIsFormEdited(false);
			setReviewFormData(reviewFormStaticDataObj);
			setShowEditor(false);
		} catch (error) {
			console.error(error);
		}
	};
	const handleSubmitCommentClick = async (event: any, reviewFormDataDetails: any, type = 'Add') => {
		try {
			if (reviewFormDataDetails?.comments) {
				setLoader(true);
				const requestPayload = {
					commentDetailsId: reviewFormDataDetails?.commentDetailsId || Enums.ZERO,
					comments: reviewFormDataDetails?.comments || '',
					moduleDetailsId: feedbackDetails?.feedbackId || Enums.ZERO,
					moduleId: Enums.FOUR,
				};
				const response: any = await dispatch(savePipComments(requestPayload));
				if (response?.data?.status === Enums.STATUS_SUCCESS) {
					if (type === 'Add') {
						handleCancelCommentClick(event);
					} else if (type === 'View') {
					}
					if (feedbackDetails?.feedbackId) {
						getPipCommentsApiCall(feedbackDetails?.feedbackId);
					}
					setLoader(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('error', messages || `Error occurred while adding comment.`);
					setLoader(false);
				}
				setIsFormEdited(false);
			} else {
				if (type === 'Add') {
					setReviewFormData({ ...reviewFormData, commentsError: 'Comment is required to Resolve PIP' });
				} else if (type === 'View') {
					let updatedCommentListDetails =
						commentListDetails && commentListDetails?.length ? [...commentListDetails] : [];
					updatedCommentListDetails = updatedCommentListDetails?.map((item: any) => {
						const data = { ...item };
						if (item?.commentDetailsId === reviewFormDataDetails?.commentDetailsId) {
							data.commentsError = 'Comment is required to Resolve PIP';
						}
						return data;
					});
					setCommentListDetails(updatedCommentListDetails);
				}
			}
		} catch (error) {
			console.error(error);
			showMsg('error', `Some error occurred`);
			setLoader(false);
		}
	};

	const handleEditCommentClick = (e: any, commentData: any) => {
		try {
			let updatedCommentListDetails = commentListDetails && commentListDetails?.length ? [...commentListDetails] : [];
			updatedCommentListDetails = updatedCommentListDetails?.map((item: any) => {
				const data = { ...item };
				if (item?.commentDetailsId === commentData?.commentDetailsId) {
					data.isEditMode = true;
				} else {
					data.isEditMode = false;
				}
				return data;
			});
			setIsFormEdited(true);
			setCommentListDetails(updatedCommentListDetails);
		} catch (error) {
			console.error(error);
			showMsg('error', `Some error occurred`);
			setLoader(false);
		}
	};
	const handleChangeCommentValueOnEdit = (value: any, comment: any, commentIndex: number) => {
		let updatedCommentListDetails = commentListDetails && commentListDetails?.length ? [...commentListDetails] : [];
		if (updatedCommentListDetails?.length > 0) {
			updatedCommentListDetails[commentIndex].comments = value;
			updatedCommentListDetails[commentIndex].commentsError = '';
		}
		setIsFormEdited(true);
		setCommentListDetails(updatedCommentListDetails);
	};
	const handleCancelCommentClickOnEdit = (e: any, commentData: any, commentIndex: number) => {
		let updatedCommentListDetails = commentListDetails && commentListDetails?.length ? [...commentListDetails] : [];
		updatedCommentListDetails = updatedCommentListDetails?.map((item: any) => {
			const data = { ...item };
			if (item?.commentDetailsId === commentData?.commentDetailsId) {
				data.isEditMode = false;
				data.comments = data?.historyComments || '';
			}
			return data;
		});
		setCommentListDetails(updatedCommentListDetails);
		setIsFormEdited(false);
	};
	const handleSubmitCommentClickOnEdit = (e: any, commentData: any, commentIndex: number) => {
		if (commentData?.comments) {
			handleSubmitCommentClick(e, commentData, 'View');
		} else {
			let updatedCommentListDetails = commentListDetails && commentListDetails?.length ? [...commentListDetails] : [];
			updatedCommentListDetails = updatedCommentListDetails?.map((item: any) => {
				const data = { ...item };
				if (item?.commentDetailsId === commentData?.commentDetailsId) {
					data.commentsError = 'Comment is required to Resolve PIP';
				}
				return data;
			});
			setCommentListDetails(updatedCommentListDetails);
		}
	};
	/**  */
	const handleDeleteCommentClick = (e: any, commentData: any) => {
		try {
			setModalProps({
				open: true,
				details: { commentData },
				type: 'DeleteComment',
				message: t('Are you sure you want to delete this comment?'),
			});
		} catch (error) {
			console.error(error);
			showMsg('error', `Some error occurred`);
			setLoader(false);
		}
	};
	const handleCloseModal = (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalProps?.type === 'DeleteComment') {
				const { commentData } = modalProps?.details || {};
				deleteCommentApiCall(commentData);
			}
		}
		setModalProps({ open: false, details: null, message: '' });
	};
	const deleteCommentApiCall = async (commentData: any) => {
		try {
			if (commentData?.commentDetailsId) {
				setLoader(true);
				const response: any = await dispatch(deletePipComment(`commentDetailsId=${commentData?.commentDetailsId}`));
				if (response?.data?.status === Enums.STATUS_SUCCESS) {
					if (feedbackDetails?.feedbackId) {
						getPipCommentsApiCall(feedbackDetails?.feedbackId);
					}
					setLoader(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('error', messages || `Error occurred while adding comment.`);
					setLoader(false);
				}
				handleClose();
			} else {
				showMsg('error', `Some error occurred`);
			}
		} catch (error) {
			console.error(error);
			showMsg('error', `Some error occurred`);
			handleClose();
			setLoader(false);
		}
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Box className='full-rectangular-card reviewers-comment'>
				<Box className='reviewer-info '>
					<Typography variant='h6'>Reviewers in this review</Typography>
					<Box className='pip-reviewers-list'>
						<Box className='review-others'>
							<UserAvatarGroup
								{...props}
								contributorClassName={'contributor-details-popover'}
								isButtonVisible={false}
								handleAddUserClick={() => {}}
								contributorDetailsType={true}
								isOnHoverVisible={true}
								loginUserAvatar={creatorDetailsVal}
								contributorDetails={reviewerDetailsVal && reviewerDetailsVal?.length ? [...reviewerDetailsVal] : []}
								isUserPlaceholder={true}
								subTitle={' '}
								helpText={' '}
								max={5}
								//isUserAvatarClick={type !== 'Add' && editableDetails ? true : false}
								//handleUserAvatarClick={handleUserAvatarClick}
								isDisabled={true}
								viewType='pipReviewers'
							/>
						</Box>
					</Box>
				</Box>
				<Box className='reviewers-post-comment'>
					{feedbackFormType !== 'PIP' &&
					(feedbackDetails?.feedbackStatusId === Enums.THREE ||
						feedbackDetails?.feedbackStatusId === Enums.ONE ||
						feedbackDetails?.feedbackStatusId === Enums.TWO) &&
					feedbackDetails?.isFeedbackEditRights ? (
						<Box className='reviewers-comment-top'>
							<Box className='user-info'>
								<Box className='user-img'>
									{/* <Avatar className='avatar-default'>DF</Avatar> */}
									{userDetails ? (
										<Tooltip arrow title={`${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`}>
											{userDetails?.imagePath ? (
												<Avatar className='avatar-default' src={userDetails.imagePath} />
											) : (
												<Avatar className={'avatar-default'}>
													{getUserName({
														firstName: userDetails?.firstName || '',
														lastName: userDetails?.lastName || '',
														fullName: userDetails?.fullName || '',
													})}
												</Avatar>
											)}
										</Tooltip>
									) : (
										<></>
									)}
								</Box>
							</Box>
							<FeedbackReviewerCommentForm
								loader={loader}
								reviewFormData={reviewFormData}
								handleChangeCommentValue={handleChangeCommentValue}
								handleCancelCommentClick={handleCancelCommentClick}
								handleSubmitCommentClick={(e: any) => handleSubmitCommentClick(e, reviewFormData, 'Add')}
								showEditor={showEditor}
								setShowEditor={setShowEditor}
							/>
						</Box>
					) : (
						<></>
					)}
					<Box className='reviewers-post-comment-list'>
						{reviewDatesComments?.commentCount ? (
							<Typography variant='h6' className='cmt-count'>
								{`${reviewDatesComments?.commentCount} ${t('commentsLabel')}`}
							</Typography>
						) : (
							<></>
						)}

						{commentListDetails && commentListDetails?.length ? (
							commentListDetails?.map((comment: any, commentIndex: number) => {
								return (
									<Box
										className={`reviewers-post-comment-row ${
											highlightCommentId == comment.commentDetailsId ? 'highlight-row' : ''
										}`}
									>
										{/* ${
										pipImprovementData?.commentId === comment.commentDetailsId ? 'highlight-row' : ''
									} */}
										<Box className='user-info'>
											<Box className='user-img'>
												{comment?.imagePath ? (
													<Avatar className='avatar-default' src={comment.imagePath} />
												) : (
													<Avatar className={'avatar-default'}>
														{getUserName({
															firstName: comment?.firstName || '',
															lastName: comment?.lastName || '',
															fullName: comment?.fullName || '',
														})}
													</Avatar>
												)}
											</Box>
										</Box>
										<Box className='reviewers-post-box'>
											<Box className='post-content-head'>
												<Box className='post-content-head-left'>
													<Typography>{getFullName(comment)}</Typography>
													{comment?.createdOn ? (
														<Typography variant='h6' className='font-weight-normal'>
															{`${getTime(comment?.createdOn)}`}
														</Typography>
													) : (
														<></>
													)}
												</Box>
												<Box className='post-content-head-right'>
													{feedbackFormType !== 'PIP' &&
													userDetails?.employeeId === comment?.employeeId &&
													(feedbackDetails?.feedbackStatusId === Enums.THREE ||
														feedbackDetails?.feedbackStatusId === Enums.ONE ||
														feedbackDetails?.feedbackStatusId === Enums.TWO) ? (
														<PopperMenu
															className={'user-menu-btn'}
															anchorEl={anchorEl}
															handleClose={handleClose}
															includeKebabMenu={true}
															menuClicked={popperMenuClicked}
															setPopperMenuClicked={setPopperMenuClicked}
															{...props}
															children={
																<>
																	<ListItem
																		onClick={(e: any) => {
																			handleClose();
																			handleEditCommentClick(e, comment);
																		}}
																	>
																		<ListItemAvatar>
																			<EditIcon />
																		</ListItemAvatar>
																		<ListItemText primary={t('editLabel')} />
																	</ListItem>
																	<ListItem
																		onClick={(e: any) => {
																			handleClose();
																			handleDeleteCommentClick(e, comment);
																		}}
																	>
																		<ListItemAvatar>
																			<DeleteIcon />
																		</ListItemAvatar>
																		<ListItemText primary={t('delete')} />
																	</ListItem>
																</>
															}
														/>
													) : (
														<></>
													)}
												</Box>
											</Box>
											<Box className='post-content long-text'>
												{comment?.isEditMode ? (
													<>
														<Box className='reviewer-post-editor-box'>
															<Box className='editor-pane'>
																<Box className='cfr-control-section helperText-bottom' id='rteImage'>
																	<CkEditor
																		placeholder={t('writeYourComment')}
																		showEmoticons={true}
																		value={comment?.comments || ''}
																		handleEditorChange={(value: string) => {
																			if (comment?.comments !== value) {
																				handleChangeCommentValueOnEdit(value, comment, commentIndex);
																			}
																		}}
																	/>
																	{comment?.commentsError ? (
																		<Typography className='error-field'>{comment?.commentsError}</Typography>
																	) : (
																		<></>
																	)}
																</Box>
															</Box>
															<Box className='reviewer-post-action'>
																<OKRButton
																	disabled={Boolean(loader)}
																	className='btn-link'
																	text={t('cancelBtn')}
																	handleClick={(e) => handleCancelCommentClickOnEdit(e, comment, commentIndex)}
																/>
																<OKRButton
																	disabled={Boolean(loader)}
																	className='btn-primary'
																	text={t('postLabel')}
																	handleClick={(e: any) => handleSubmitCommentClickOnEdit(e, comment, commentIndex)}
																/>
															</Box>
														</Box>
													</>
												) : (
													<Box
														dangerouslySetInnerHTML={{
															__html: comment?.comments || '',
														}}
													></Box>
												)}
											</Box>
										</Box>
									</Box>
								);
							})
						) : (
							<></>
						)}
					</Box>
					{/* No Record content */}
					{!reviewDatesComments?.commentCount &&
					!commentListDetails?.length &&
					feedbackDetails?.feedbackStatusId > Enums.THREE ? (
						<Box className='user-no-record'>
							<Typography variant='h2'>{t('feedbackResolved')}</Typography>
							<Typography>{t('feedbackResolvedText')}</Typography>
							<AnimatedIcon
								className=''
								width='230'
								type='image/svg+xml'
								alt={t('globalSearchNoRecord')}
								imagePath={NofoundImg}
							/>
						</Box>
					) : !reviewDatesComments?.commentCount && !commentListDetails?.length ? (
						<Box className='user-no-record'>
							<Typography variant='h2'>{t('noCommentsYet')}</Typography>
							<Typography>{t('firstReviewerComment')}</Typography>
							<AnimatedIcon
								className=''
								width='230'
								type='image/svg+xml'
								alt={t('globalSearchNoRecord')}
								imagePath={NofoundImg}
							/>
						</Box>
					) : (
						<></>
					)}
				</Box>
			</Box>

			{modalProps?.open && (
				<AlertDialog
					message={modalProps?.message || ''}
					handleCloseModal={handleCloseModal}
					modalOpen={modalProps.open}
				/>
			)}
		</>
	);
};
